import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const httpOptions = {  headers: new HttpHeaders({    'Content-Type':  'application/json'    //,     //'Authorization': 'my-auth-token'  
})};

export class Register
{
  email:string;
  firstname:string;
  lastname:string;
  title:string;
  userid:string;
  accounttype:number;
  phone:string;
  phoneExt:string;
}

export class ResellerRegister
{
  email:string;
  firstname:string;
  lastname:string;
  title:string;
  userid:string;
  accounttype:number;
  phone:string;
  phoneExt:string;
  companyName:string;
  address1:string;
  address2:string;
  city:string;
  country:number;
  province:string;
  postalCode:string;
  group:string;
  currentlyInGroup:string;
  currentlyInGroupName:string;
  ipAddress:string;
  synnex_CA:string;
  techdata_CA:string;
  ingramMicro_CA:string;
  dandH_CA:string;
  asi_CA:string;
  synnex_USA:string;
  techdata_USA:string;
  ingramMicro_USA:string;
  dandH_USA:string;
  asi_USA:string;
}


export class Country
{
  id:number;
  name:string;
}

export class Province
{
  id:number;
  name:string;
}


@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private http: HttpClient) { } 

  add(register:Register):Observable<any>{
    //alert('2');
    return this.http.post<any>(`https://whscorp.com/api/v1`,register);  
  }
  isEmailAlreadyExists(email:string):Observable<boolean>{
    return this.http.get<boolean>(`https://whscorp.com/api/v1/isEmailAlreadyExists?email=${email}`);  
  }
  isUserIdAlreadyExists(userid:string):Observable<boolean>{
    return this.http.get<boolean>(`https://whscorp.com/api/v1/isUserIdAlreadyExists?userid=${userid}`);  
  }
  isDistEmailAlreadyExists(email:string):Observable<boolean>{
    return this.http.get<boolean>(`https://whscorp.com/api/v1/isDistributorEmailAlreadyExists?email=${email}`);  
  }
  isResellerEmailAlreadyExists(email:string):Observable<boolean>{
    return this.http.get<boolean>(`https://whscorp.com/api/v1/isResellerEmailAlreadyExists?email=${email}`);  
  }
  isManuEmailAlreadyExists(email:string):Observable<boolean>{
    return this.http.get<boolean>(`https://whscorp.com/api/v1/isManufacturerEmailAlreadyExists?email=${email}`);  
  }

  addReseller(register:ResellerRegister):Observable<any>{
    //alert('2');
    return this.http.post<any>(`https://whscorp.com/api/v1/ResellerRegister`,register);  
  }

  getAllCounties():Observable<any>{    
    return this.http.get<Country[]>(`https://whscorp.com/api/v1/ResellerRegister/GetCountries`);  
  }  
  

  getAllByCountryId(id: number):Observable<any>{    
    return this.http.get<Province[]>(`https://whscorp.com/api/v1/ResellerRegister/GetProvinces?countryId=${id}`);  
  }

  sendEmailToAlreadyExists(email:string):Observable<boolean>{
    return this.http.get<boolean>(`https://whscorp.com/api/v1/ResellerRegister/ToExistingAC?email=${email}`);  
  }

  sendEmailToAnyAlreadyExists(email:string):Observable<boolean>{
    return this.http.get<boolean>(`https://whscorp.com/api/v1/ResellerRegister/ToAnyExistingAC?email=${email}`);  
  }
  

}
